/**
 * Firm-level module enable/disable route guards.
 * SaaS Admin sets plan ceilings; Firm Admin toggles module_states per branch.
 */
import { redirect } from "@tanstack/react-router";
import { useModuleStore, type ERPModuleKey } from "@/lib/module-store";
import { guardRoute } from "@/lib/permissions";

const PATH_MODULE_MAP: Array<{ prefix: string; module: ERPModuleKey }> = [
  { prefix: "/orders", module: "orders" },
  { prefix: "/billing", module: "billing" },
  { prefix: "/stock", module: "inventory" },
  { prefix: "/barcode", module: "barcode" },
  { prefix: "/workshop", module: "manufacturing" },
  { prefix: "/melt", module: "manufacturing" },
  { prefix: "/settlement", module: "manufacturing" },
  { prefix: "/manufacturing", module: "manufacturing" },
  { prefix: "/refinery", module: "manufacturing" },
  { prefix: "/ledger", module: "billing" },
  { prefix: "/treasury", module: "billing" },
];

export function resolveModuleKeyForPath(pathname: string): ERPModuleKey | null {
  const path = pathname.split("?")[0];
  for (const entry of PATH_MODULE_MAP) {
    if (path === entry.prefix || path.startsWith(`${entry.prefix}/`)) {
      return entry.module;
    }
  }
  return null;
}

/**
 * Workspace + role guard, then firm module toggle enforcement.
 */
export function guardModuleRoute(pathname: string): void {
  guardRoute(pathname);
  const moduleKey = resolveModuleKeyForPath(pathname);
  if (!moduleKey) return;
  if (!useModuleStore.getState().isModuleEnabled(moduleKey)) {
    throw redirect({
      to: "/app",
      search: { moduleDisabled: moduleKey },
    });
  }
}
